import { CheckedState } from "@radix-ui/react-checkbox"
import { DetailCheckbox } from "@/components/ui/checkbox.tsx"
import { cn } from "@/lib/utils.ts"
import { PURPOSE_POINT_OF_CARE_ITEMS } from "@/modules/patients/detail/progress-note/point-of-care/constants"
import type { Purpose } from "@/modules/patients/detail/progress-note/point-of-care/types"

interface PurposePointOfCareSelectionProps {
  label?: string
  containerClassName?: string
  value?: Purpose[]
  isChecked: (item: Purpose) => boolean
  onChange: (item: Purpose[]) => void
}

const PurposePointOfCareSelection = ({
  value = [],
  label,
  containerClassName,
  isChecked,
  onChange,
}: PurposePointOfCareSelectionProps): React.JSX.Element => {
  return (
    <div className={cn("flex flex-col gap-2 pt-4", containerClassName)} data-testid="purpose-selection">
      <label className="text-on-surface-subdued text-sm leading-5">{label}</label>
      <div className="flex flex-wrap gap-2">
        {PURPOSE_POINT_OF_CARE_ITEMS.map((item) => {
          const checked = isChecked(item.value)
          return (
            <DetailCheckbox
              data-testid={`purpose-${item.value}-checkbox`}
              key={item.value}
              className="pr-3 capitalize"
              checked={checked}
              onCheckedChange={(checkedState: CheckedState): void =>
                checkedState
                  ? onChange([...value, item.value])
                  : onChange(value.filter((selectedPurpose: Purpose): boolean => selectedPurpose !== item.value))
              }>
              {item.label}
            </DetailCheckbox>
          )
        })}
      </div>
    </div>
  )
}

export { PurposePointOfCareSelection }
